import React from 'react';
import AdminPortal from '@/pages/admin/AdminPortal';

export default function PastorPortal() {
  return <AdminPortal pastorMode />;
}
